// src/routes.jsx
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

// Layout
import { Layout } from './components/common/Layout/Layout.jsx';
import { AdminLayout } from './pages/Admin/AdminLayout.jsx';

// Страницы
import { Home } from './pages/Home/Home.jsx';
import { Stickers } from './pages/Stickers/Stickers.jsx';
import { LoginPage, RegisterPage } from './pages/Auth/AuthPage.jsx';
import { Catalog } from './pages/Catalog/Catalog.jsx';
import { ProductPage } from './pages/Product/ProductPage.jsx';
import { Cart } from './pages/Cart/Cart.jsx';
import { Checkout } from './pages/Checkout/Checkout.jsx';
import { Orders } from './pages/Orders/Orders.jsx';
import { OrderDetail } from './pages/OrderDetail/OrderDetail.jsx';
import { Favorites } from './pages/Favorites/Favorites.jsx';
import { Cases } from './pages/Cases/Cases.jsx';
import { CaseDetail } from './pages/CaseDetail/CaseDetail.jsx';
import { Blog } from './pages/Blog/Blog.jsx';
import { BlogPost } from './pages/BlogPost/BlogPost.jsx';
import { Support } from './pages/Support/Support.jsx';
import { Profile } from './pages/Profile/Profile.jsx';

// Админ-страницы
import { AdminDashboard } from './pages/Admin/AdminDashboard.jsx';
import { AdminProducts } from './pages/Admin/AdminProducts.jsx';
import { AdminProductForm } from './pages/Admin/AdminProductForm.jsx';
import { AdminCategories } from './pages/Admin/AdminCategories.jsx';
import { AdminCaseForm } from './pages/Admin/AdminCaseForm.jsx';
import { AdminCategoryForm } from './pages/Admin/AdminCategoryForm.jsx';
import { AdminOrderDetail } from './pages/Admin/AdminOrderDetail.jsx';
import { AdminOrders } from './pages/Admin/AdminOrders.jsx';
import { AdminBlog } from './pages/Admin/AdminBlog.jsx';
import { AdminBlogForm } from './pages/Admin/AdminBlogForm.jsx';
import { AdminCases } from './pages/Admin/AdminCases.jsx';
import { AdminUsers } from './pages/Admin/AdminUsers.jsx';
import { AdminSupport } from './pages/Admin/AdminSupport.jsx';

// Информационные страницы
import { About } from './pages/About/About.jsx';
import { Contacts } from './pages/Contacts/Contacts.jsx';
import { Delivery } from './pages/Delivery/Delivery.jsx';
import { Returns } from './pages/Returns/Returns.jsx';
import { Privacy } from './pages/Privacy/Privacy.jsx';
import { Terms } from './pages/Terms/Terms.jsx';
import { Corporate } from './pages/Corporate/Corporate.jsx';
import { Partners } from './pages/Partners/Partners.jsx';
import { Academy } from './pages/Academy/Academy.jsx';
import { Deals } from './pages/Deals/Deals.jsx';
import { Services } from './pages/Services/Services.jsx';
import { Packages } from './pages/Packages/Packages.jsx';

// Страницы ошибок
import { NotFound } from './pages/NotFound/NotFound.jsx';

export const router = createBrowserRouter([
  // Основной сайт
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <Home /> },
      // «Мы превращаем идеи в стикеры» — отдельное приложение внутри сайта.
      { path: 'stickers', element: <Stickers /> },
      // Вход и регистрация КАК МАРШРУТЫ (были только модалкой): без адреса
      // нельзя вернуть человека туда, откуда он пришёл, и нельзя дать ссылку.
      { path: 'login', element: <LoginPage /> },
      { path: 'register', element: <RegisterPage /> },
      { path: 'catalog', element: <Catalog /> },
      { path: 'catalog/:category', element: <Catalog /> },
      { path: 'product/:id', element: <ProductPage /> },
      { path: 'cart', element: <Cart /> },
      { path: 'checkout', element: <Checkout /> },
      { path: 'orders', element: <Orders /> },
      { path: 'orders/:id', element: <OrderDetail /> },
      { path: 'favorites', element: <Favorites /> },
      { path: 'cases', element: <Cases /> },
      { path: 'cases/:id', element: <CaseDetail /> },
      { path: 'blog', element: <Blog /> },
      { path: 'blog/:id', element: <BlogPost /> },
      { path: 'support', element: <Support /> },
      { path: 'profile', element: <Profile /> },
      { path: 'about', element: <About /> },
      { path: 'contacts', element: <Contacts /> },
      { path: 'delivery', element: <Delivery /> },
      { path: 'returns', element: <Returns /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'terms', element: <Terms /> },
      { path: 'corporate', element: <Corporate /> },
      { path: 'partners', element: <Partners /> },
      { path: 'academy', element: <Academy /> },
      { path: 'deals', element: <Deals /> },
      { path: 'services', element: <Services /> },
      { path: 'packages', element: <Packages /> },
      { path: '*', element: <NotFound /> },
    ],
  },

{
  path: '/admin',
  element: <AdminLayout />,
  children: [
    { index: true, element: <AdminDashboard /> },
    { path: 'products', element: <AdminProducts /> },
    { path: 'products/new', element: <AdminProductForm /> },
    { path: 'products/:id', element: <AdminProductForm /> },
    { path: 'categories', element: <AdminCategories /> },
    { path: 'categories/new', element: <AdminCategoryForm /> },
    { path: 'categories/:id', element: <AdminCategoryForm /> },
    { path: 'orders', element: <AdminOrders /> },
    { path: 'orders/:id', element: <AdminOrderDetail /> },
    { path: 'blog', element: <AdminBlog /> },
    { path: 'blog/new', element: <AdminBlogForm /> },
    { path: 'blog/:id', element: <AdminBlogForm /> },
    { path: 'cases', element: <AdminCases /> },
    { path: 'cases/new', element: <AdminCaseForm /> },
    { path: 'cases/:id', element: <AdminCaseForm /> },
    { path: 'users', element: <AdminUsers /> },
    { path: 'support', element: <AdminSupport /> },
  ],
},
]);